import translate from '@i18n'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import NameWithUrl from './NameWithUrl'
import { ListAuthor } from './types'
import { getUrlProps } from './utils'
import useIsInRecipeContent from '@hooks/useIsInRecipeContent'

interface MultipleAuthorsProps {
  children: ListAuthor[]
}

interface MultipleAuthorsWrapperProps {
  isInRecipeContent?: boolean
}

const Name = styled.span`
  font-family: ${({ theme }) => theme.fonts.sourceSansPro};
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
`

const MultipleAuthorsWrapper = styled.div<MultipleAuthorsWrapperProps>`
  ${({
    theme: {
      measures: {
        content: { defaultMargin },
      },
      fonts: { sourceSansPro },
    },
    isInRecipeContent,
  }) => {
    return css`
      font-family: ${sourceSansPro};
      font-size: 14px;
      line-height: 16px;
      font-weight: bold;
      ${!isInRecipeContent &&
      css`
        margin: ${defaultMargin} 8px ${defaultMargin} 0;
      `}
    `
  }}
`

const MultipleAuthors: FunctionComponent<MultipleAuthorsProps> = ({
  children,
}) => {
  const lastIndex = children.length - 1
  const isInRecipeContent = useIsInRecipeContent()

  const getSeparatorChar = (index: number) =>
    index === 0 ? '' : index === lastIndex ? ` ${translate('and')} ` : ', '

  return (
    <MultipleAuthorsWrapper isInRecipeContent={isInRecipeContent}>
      {translate('author.by')}{' '}
      {children.map((author, index) => [
        getSeparatorChar(index),
        author.url ? (
          <NameWithUrl
            key={`author-${index}`}
            urlProps={getUrlProps(author.url)}
            name={author.name}
          />
        ) : (
          <Name key={`author-${index}`}>{author.name}</Name>
        ),
      ])}
    </MultipleAuthorsWrapper>
  )
}

export default MultipleAuthors
